// Cards API for DIOS10
import apiClient from './client';
import { API_ENDPOINTS } from './config';

export const cardsApi = {
    // Get card by ID
    /** @param {number} id @param {{ templateId?: number, rarity?: string }} [opts] */
    getById: async (id, opts = {}) => {
        try {
            const params = {};
            if (opts.templateId != null && !Number.isNaN(Number(opts.templateId))) {
                params.templateId = Number(opts.templateId);
            }
            if (opts.rarity != null && String(opts.rarity).trim() !== '') {
                params.rarity = String(opts.rarity).trim();
            }
            const response = await apiClient.get(API_ENDPOINTS.CARDS.GET_BY_ID(id), {
                params: Object.keys(params).length ? params : undefined
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get next match for a card (on-demand)
    /** @param {number} id @param {number} [templateId] @param {string} [rarity] — con templateId + rarity si evitano collisioni tra cards_* */
    getPlayerRecentScores: async (playerId, limit = 5) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.CARDS.PLAYER_RECENT_SCORES(playerId), {
                params: { limit },
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    getNextMatch: async (id, templateId, rarity) => {
        try {
            const params = {};
            if (templateId != null && !Number.isNaN(Number(templateId))) {
                params.templateId = Number(templateId);
            }
            if (rarity != null && String(rarity).trim() !== '') {
                params.rarity = String(rarity).trim();
            }
            const response = await apiClient.get(API_ENDPOINTS.CARDS.GET_NEXT_MATCH(id), {
                params: Object.keys(params).length ? params : undefined
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Batch next matches.
     * @param {number[]} cardIds
     * @param {Record<number, number>} [templateIdByCardId] — cardId -> template_id
     * @param {Record<number, string>} [rarityByCardId] — cardId -> rarity name (es. "rare")
     * @param {Record<number, number>} [playerIdByCardId] — cardId -> player_id già risolto dalla card
     */
    getNextMatchesBatch: async (cardIds, templateIdByCardId, rarityByCardId, playerIdByCardId) => {
        try {
            const body = { cardIds };
            if (templateIdByCardId && typeof templateIdByCardId === 'object' && Object.keys(templateIdByCardId).length) {
                body.templateIdByCardId = templateIdByCardId;
            }
            if (rarityByCardId && typeof rarityByCardId === 'object' && Object.keys(rarityByCardId).length) {
                body.rarityByCardId = rarityByCardId;
            }
            if (playerIdByCardId && typeof playerIdByCardId === 'object' && Object.keys(playerIdByCardId).length) {
                body.playerIdByCardId = playerIdByCardId;
            }
            const response = await apiClient.post(API_ENDPOINTS.CARDS.NEXT_MATCHES_BATCH, body);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Get user cards
    getUserCards: async (userId, filters = {}) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.CARDS.GET_USER_CARDS(userId), {
                params: filters
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Search players
    searchPlayers: async (searchTerm, filters = {}) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.CARDS.SEARCH_PLAYERS, {
                params: { q: searchTerm, ...filters }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    getCoachTrainingActiveCards: async (userId) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.CARDS.COACH_TRAINING_ACTIVE_CARDS, {
                params: { userId }
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    getCoachTrainingSession: async ({ loanId, cardId, userId }) => {
        try {
            const params = { userId };
            if (loanId != null) params.loanId = loanId;
            if (cardId != null) params.cardId = cardId;
            const response = await apiClient.get(API_ENDPOINTS.CARDS.COACH_TRAINING_SESSION, {
                params
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    startCoachTraining: async ({ loanId, cardId, userId, trainees }) => {
        try {
            const body = { userId, trainees };
            if (loanId != null) body.loanId = loanId;
            if (cardId != null) body.cardId = cardId;
            const response = await apiClient.post(API_ENDPOINTS.CARDS.COACH_TRAINING_START, body);
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Search player cards summary
    searchPlayerCards: async (searchTerm, limit = 5) => {
        try {
            const response = await apiClient.get(API_ENDPOINTS.CARDS.SEARCH_PLAYER_CARDS, {
                params: { q: searchTerm, limit }
            });
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export default cardsApi;

